import { useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  DatePicker,
  Divider,
  Flex,
  Input,
  Select,
  Spin,
  Table,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { getStockBalance } from '../../network/stockBalanceReport';
import { queryKeys } from '../../services/react-query/queryKeys';
import { getStockLedgerReport } from '../../network/stockLedgerReport';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getSearchApi } from '../../network/itemList';
import { useParams } from 'react-router-dom';
import { getPurchaseRecieptDetails } from '../../network/purchaseReciept';
import {
  getDebitNote,
  getPurchaseInvoiceDetails,
} from '../../network/purchaseInvoice';
import { getSalesInvoiceDetails } from '../../network/PaymentEntry';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const StockLedgerReport = ({ t, invoice, reciept, note, credit }) => {
  const { idInvoice, idReciept, idNote, idCreditNote } = useParams();
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    warehouse: '',
    item_code: '',
    stock_uom: '',
    voucher_no: '',
  });
  console.log(sourceData, 'sourceData');

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getStockLedgerReport,
      currentLang,
      currentLang,
      sourceData.from_date,
      sourceData.to_date,
      sourceData.warehouse,
      sourceData.item_code,
      sourceData.stock_uom,
      sourceData.voucher_no,
    ],
    queryFn: () =>
      getStockLedgerReport(
        currentLang,
        companyName,
        sourceData.from_date,
        sourceData.to_date,
        sourceData.warehouse,
        sourceData.item_code,
        sourceData.stock_uom,
        sourceData.voucher_no
      ),
  });
  const { message } = App.useApp();
  const { data: Warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouseSearch],
    queryFn: () => getSearchApi('Warehouse'),
    keepPreviousData: true,
  });
  const { data: items } = useQuery({
    queryKey: [queryKeys.getItemsSearch],
    queryFn: () => getSearchApi('Item'),
    keepPreviousData: true,
  });
  // const { data: salesInvoice, isLoading: loadingSales } = useQuery({
  //   queryKey: [queryKeys.getSalesInvoiceDetails, idCreditNote],
  //   queryFn: () => getSalesInvoiceDetails(idCreditNote),
  //   keepPreviousData: true,
  //   enabled: !!credit,
  // });
  const { data: recieptDetails, isLoading: recieptLoading } = useQuery({
    queryKey: [queryKeys.getPurchaseReciept, idReciept],
    queryFn: () => getPurchaseRecieptDetails(idReciept),
    keepPreviousData: true,
    enabled: !!idReciept && reciept,
  });
  const { data: debitNoteDetails, isLoading: LoadingNoteDetails } = useQuery({
    queryKey: [queryKeys.getDebitNote, idNote],
    queryFn: () => getDebitNote(idNote),
    enabled: !!note,
  });
  const { data: invoiceDetails, isLoading: invoiceLoading } = useQuery({
    queryKey: [queryKeys.getPurchaseInvoice, idInvoice],
    queryFn: () => getPurchaseInvoiceDetails(idInvoice),
    keepPreviousData: true,
    enabled: !!idInvoice && invoice,
  });
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));
  useEffect(() => {
    if (credit && idCreditNote) {
      setSourceData({
        ...sourceData,
        from_date: dayjs().format('YYYY-MM-DD'),
        to_date: dayjs().add(1, 'month').format('YYYY-MM-DD'),
        voucher_no: idCreditNote,
      });
    }
  }, [idCreditNote, credit]);
  useEffect(() => {
    if (reciept && recieptDetails) {
      console.log(recieptDetails, 'recieptDetails');

      setSourceData({
        ...sourceData,
        from_date: dayjs(recieptDetails?.data?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(recieptDetails?.data?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        // warehouse: recieptDetails?.data?.set_warehouse,
        // item_code: recieptDetails?.data?.items[0]?.item_code,
        // stock_uom: recieptDetails?.data?.items[0]?.stock_uom,
        voucher_no: idReciept,
      });
    }
  }, [recieptDetails, idReciept, reciept]);
  useEffect(() => {
    if (note && idNote) {
      setSourceData({
        ...sourceData,
        from_date: dayjs(debitNoteDetails?.message?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(debitNoteDetails?.message?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        voucher_no: idNote,
      });
    }
  }, [note, idNote]);
  useEffect(() => {
    if (invoice && invoiceDetails) {
      console.log(invoiceDetails, 'invoiceDetails');
      setSourceData({
        ...sourceData,
        from_date: dayjs(invoiceDetails?.data?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(invoiceDetails?.data?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        // warehouse: invoiceDetails?.data?.set_warehouse,
        // item_code: invoiceDetails?.data?.items[0]?.item_code,
        // stock_uom: invoiceDetails?.data?.items[0]?.stock_uom,
        voucher_no: idInvoice,
      });
    }
  }, [invoiceDetails, idInvoice, invoice]);
  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );

  // const totalRow = stockBalanceDetails?.message?.result?.slice(-1)[0];
  if (invoiceLoading || recieptLoading || LoadingNoteDetails) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.inventory} subTitle={t.StockLedger} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Flex
          style={{
            // justifyContent: 'space-between',
            gap: '20px',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <RangePicker
            format="YYYY/MM/DD"
            style={{ width: '100%' }}
            placeholder={['From Date', 'To Date']}
            // defaultValue={[dayjs().isBefore(dayjs().add(4, 'month')), dayjs()]}
            defaultValue={[dayjs().startOf('year'), dayjs()]}
            value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
            onChange={(dates, dateStrings) => {
              setSourceData({
                from_date: dateStrings[0],
                to_date: dateStrings[1],
              });
            }}
          />
          <Select
            placeholder={t.items}
            showSearch
            allowClear
            popupMatchSelectWidth={false}
            style={{ width: '100%' }}
            // value={sourceData.item_code}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={items?.message?.map((item) => ({
              value: item?.value,
              label: item?.value,
            }))}
            onChange={(value) => {
              setSourceData({
                ...sourceData,
                item_code: value,
              });
            }}
          />
          <Select
            placeholder={t.warehouse}
            showSearch
            allowClear
            popupMatchSelectWidth={false}
            // value={sourceData.warehouse}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={Warehouse?.message?.map((item) => ({
              value: item?.value,
              label: item?.value,
            }))}
            style={{ width: '100%' }}
            onChange={(value) => {
              setSourceData({
                ...sourceData,
                warehouse: value,
              });
            }}
          />
          <Input
            placeholder={t.VoucherNo}
            allowClear
            value={sourceData.voucher_no}
            style={{ width: '100%' }}
            onChange={(e) => {
              setSourceData({
                ...sourceData,
                voucher_no: e.target.value,
              });
            }}
          />
          {/* <Select
          placeholder={t.VoucherNo}
          showSearch
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLocaleLowerCase().includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          options={purchaseReceipt?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          style={{ width: '100%' }}
          onChange={(value) => {
            setSourceData({
              ...sourceData,
              voucher_no: value,
            });
          }}
        /> */}
          {/* <h3>{t.StockBalanceList}</h3> */}
        </Flex>
        <Divider orientation="left">{t.StockLedger}</Divider>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          // summary={() => (
          //   <Table.Summary.Row>
          //     {totalRow?.map((value, index) => (
          //       <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
          //     ))}
          //   </Table.Summary.Row>
          // )}
        />
      </Card>
    </div>
  );
};

export default StockLedgerReport;
